<div class="sidebar d-flex flex-column" [class.collapsed]="isCollapsed()">
  <div class="sidebar-header align-items-center justify-content-between">
    <div class="d-flex align-items-center justify-content-center">
      <a [routerLink]="['/']"
        ><img
          class="img-fluid"
          src="/assets/images/pb_logo.png"
          alt="Logo"
          class="logo"
          width="60"
          height="60"
      /></a>

      @if(!isCollapsed){
      <span class="logo-text">Pueblo Bonito</span>
      }
    </div>
  </div>

  <div class="container-options">
    <ul class="sidebar-nav flex-grow-1">
      <li
        class="nav-item"
        data-bs-toggle="tooltip"
        data-bs-placement="top"
        title="Inicio"
        [routerLink]="['/']"
        (mouseenter)="onMenuMouseEnter($event)"
        (mouseleave)="onMenuMouseLeave($event)"
        (click)="hideAllTooltips()"
      >
        <a
          routerLink="/"
          class="nav-link d-flex align-items-center"
          [class.justify-content-center]="isCollapsed()"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="#C2AB78"
            class="bi bi-house-door-fill"
            viewBox="0 0 16 16"
          >
            <path
              d="M6.5 14.5v-3.505c0-.245.25-.495.5-.495h2c.25 0 .5.25.5.5v3.5a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.146-.354L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.354 1.146a.5.5 0 0 0-.708 0l-6 6A.5.5 0 0 0 1.5 7.5v7a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5"
            />
          </svg>
          <span class="nav-text ms-3" [class.d-none]="isCollapsed()"
            >Inicio</span
          >
        </a>
      </li>

      @for (menu of menuService.menuData(); track menu.id) {
      <li
        routerLinkActive="active"
        class="nav-item"
        (click)="expand(menu, $event)"
        data-bs-toggle="tooltip"
        data-bs-placement="top"
        title="{{ menu.nombre }}"
        (mouseenter)="onMenuMouseEnter($event)"
        (mouseleave)="onMenuMouseLeave($event)"
      >
        <a
          class="nav-link d-flex align-items-center"
          [class.justify-content-center]="isCollapsed()"
        >
          <img
            src="/assets/images/sidebar/{{ menu.icono }}"
            class="img-fluid"
            width="20"
            height="20"
          />
          <span class="nav-text ms-3" [class.d-none]="isCollapsed()">{{
            menu.nombre
          }}</span>
          <i
            class="bi toogle-arrow"
            [class.bi-caret-down-fill]="menu.expanded"
            [class.bi-caret-right-fill]="!menu.expanded"
          ></i>
        </a>

        @if(menu.expanded){ @for (subMenu of menu.subMenu; track subMenu.nombre)
        {
        <ul class="submenu">
            <li class="submenu-item"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="{{ subMenu.nombre }}"
              (mouseenter)="onMenuMouseEnter($event)"
              (mouseleave)="onMenuMouseLeave($event)"
              (click)="hideAllTooltips()"
            >
            <a
              class="nav-link d-flex align-items-center submenu-content"
              [class.justify-content-center]="isCollapsed()"
              routerLink="{{ menu.nombre }}/{{ subMenu.accion }}"
            >
              <img
                src="/assets/images/sidebar/{{ subMenu.icono }}"
                class="img-fluid"
                width="20"
                height="20"
              />
              <span class="nav-text ms-3" [class.d-none]="isCollapsed()">{{
                subMenu.nombre
              }}</span>
            </a>
          </li>
        </ul>
        } }
      </li>
      }
    </ul>
  </div>

  <div class="sidebar-footer">
    <div class="nav-item" routerLink="/profile" routerLinkActive="active">
      <a class="nav-link d-flex align-items-center">
        <div
          [class.circle]="!isCollapsed()"
          [class.circle-collapsed]="isCollapsed()"
          class="d-flex justify-content-center align-items-center"
        >
          <p>{{ userFirstLetter }}</p>
        </div>
        <span class="nav-text ms-3" [class.d-none]="isCollapsed()"
          >{{ user?.nombre }}</span
        >
      </a>
    </div>
    <div
      class="nav-item"
      [class.justify-content-center]="isCollapsed()"
      [class.d-flex]="isCollapsed()"
      (click)="logout()"
    >
      <a class="nav-link d-flex align-items-center">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          class="bi bi-box-arrow-left"
          viewBox="0 0 16 16"
        >
          <path
            fill-rule="evenodd"
            d="M6 12.5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5h-8a.5.5 0 0 0-.5.5v2a.5.5 0 0 1-1 0v-2A1.5 1.5 0 0 1 6.5 2h8A1.5 1.5 0 0 1 16 3.5v9a1.5 1.5 0 0 1-1.5 1.5h-8A1.5 1.5 0 0 1 5 12.5v-2a.5.5 0 0 1 1 0z"
          />
          <path
            fill-rule="evenodd"
            d="M.146 8.354a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L1.707 7.5H10.5a.5.5 0 0 1 0 1H1.707l2.147 2.146a.5.5 0 0 1-.708.708z"
          />
        </svg>
        <span class="nav-text ms-3" [class.d-none]="isCollapsed()"
          >Cerrar Sesión</span
        >
      </a>
    </div>
  </div>

  <button class="toggle-button" (click)="toggleSidebar()">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      [ngClass]="{ 'rotate-180': isCollapsed() }"
      fill="currentColor"
      class="bi bi-arrow-left-short"
      viewBox="0 0 16 16"
    >
      <path
        fill-rule="evenodd"
        d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5"
      />
    </svg>
  </button>
</div>
